<script>
import { updateCarMissingProvisionDocumentComment } from '@/api/cars'
import Spinner from '@/components/ui/loader/Spinner.vue'

export default {
  components: {
    'mia-spinner': Spinner
  },

  props: {
    row: {
      type: Object,
      default() {
        return {}
      }
    },

    column: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data() {
    return {
      comment: this.row[this.column.field] || ''
    }
  },

  computed: {
    isDirty() {
      return this.comment !== this.row[this.column.field] || ''
    },

    canEdit() {
      return this.authUser && this.authUser.item_is_allowed_edit_missing_provision_documents_comment
    }
  },

  methods: {
    async onBlur() {
      if (!this.canEdit || !this.isDirty || this.$wait.is(`updating missing provision documents comment for ${this.row.id}`)) {
        return
      }

      this.$wait.start(`updating missing provision documents comment for ${this.row.id}`)
      const [{ value }] = await Promise.allSettled([
        updateCarMissingProvisionDocumentComment(this.row.id, this.comment),
        new Promise(resolve => window.setTimeout(resolve, 1000))
      ])
      this.$wait.end(`updating missing provision documents comment for ${this.row.id}`)
      const [error] = value

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['Kommentar konnte nicht gespeichert werden']
        })
        return
      }

      window.eventBus.$emit('mia-info', {
        info: ['Kommentar erfolgreich gespeichert']
      })
    }
  }
}
</script>

<template>
  <div class="relative">
    <textarea
      v-model="comment"
      class="p-2"
      :readonly="!canEdit"
      @blur="onBlur"
    />
    <div
      v-if="$wait.is(`updating missing provision documents comment for ${row.id}`)"
      class="absolute right-0 top-0 p-1"
    >
      <mia-spinner class="w-5 h-5 text-orange-mia" />
    </div>
  </div>
</template>
